export default "__VITE_ASSET__Bqct1sQ2__"